module.exports = __webpack_public_path__ + "static/media/img29.37221835.jpg";